import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bg from "assets/images/bg2.png";
import * as Yup from "yup";
import { useFormik } from "formik";
import ShowToast from "components/MDToast";
import { useForgotPasswordMutation } from "services/auth";
import useTranslation from "hooks/Translation";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const t = useTranslation();
  const [ForgotPasswordMutation] = useForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(t.error.emailReq)
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t.error.validEmail
        ),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      let body = {
        email: formik.values.email,
      };

      try {
        const response = await ForgotPasswordMutation(body).unwrap();
        if (response?.status === 200) {
          const data = {
            // page: 'login'
            key: formik.values.email,
            page: "forgot",
          };
          navigate("/otp-verify", { state: data });
          ShowToast(response?.message || "");
        }
      } catch (error) {
        ShowToast(error?.data?.message || "", "error");
      }
    },
  });

  return (
    <BasicLayout>
      <Grid
        container
        className="signin-container"
        sx={{ overflow: "hidden", minHeight: "100vh" }}
      >
        {/* Image Section */}
        <Grid
          item
          xs={0}
          md={6}
          sx={{
            display: { xs: "none", md: "block" },
            position: "relative",
            background: "black",
            height: "100vh",
          }}
        >
          <img
            src={bg}
            alt="Sign In"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              marginTop: "-2px",
            }}
          />
        </Grid>

        {/* Form Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 4, sm: 8 },
          }}
        >
          {/* <Card> */}
          <MDBox sx={{ maxWidth: 500, width: "100%" }} pt={5}>
            <MDBox
              // variant="gradient"
              // bgColor="#2B604C"
              borderRadius="lg"
              // coloredShadow="info"
              mx={2}
              // mt={-3}
              // p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" mt={1}>
                {t.auth.forgotPassword}
              </MDTypography>
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <form onSubmit={formik.handleSubmit}>
                <MDBox mb={2}>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.auth.email}
                  </MDTypography>
                  <MDInput
                    className="text_field"
                    type="text"
                    placeholder={t.auth.email}
                    fullWidth
                    id="email"
                    name="email"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    helperText={formik.touched.email && formik.errors.email}
                    error={formik.touched.email && formik.errors.email}
                  />
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton
                    // onClick={() => navigate("/otp-verify", { state: "forgot" })}
                    variant="gradient"
                    color="success"
                    fullWidth
                    type="submit"
                  >
                    {t.auth.verify}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>
          </MDBox>

          {/* </Card> */}
        </Grid>
      </Grid>
    </BasicLayout>
  );
}
